module.exports = __webpack_public_path__ + "static/media/Avitech_Sotware_Solutions_Brochure.42ff1474.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brochures/Avitech_Sotware_Solutions_Brochure.pdf
// module id = 575
// module chunks = 0